import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=334d21ea&scoped=true&"
import script from "./explain.vue?vue&type=script&lang=js&"
export * from "./explain.vue?vue&type=script&lang=js&"
import style0 from "./explain.vue?vue&type=style&index=0&id=334d21ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d21ea",
  null
  
)

export default component.exports